'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["scrollBehavior", "slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { useChatLocaleText } from "../chat/internals/ChatLocaleContext.js";
import { getDataAttributes } from "../internals/getDataAttributes.js";
import { mergeReactProps } from "../internals/mergeReactProps.js";
import { useMessageListContext } from "../message-list/internals/MessageListContext.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ScrollToBottomAffordance = /*#__PURE__*/React.forwardRef(function ScrollToBottomAffordance(props, ref) {
  const {
      scrollBehavior,
      slots,
      slotProps
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    isAtBottom,
    scrollToBottom,
    unseenMessageCount
  } = useMessageListContext();
  const localeText = useChatLocaleText();
  const label = React.useMemo(() => unseenMessageCount > 0 ? localeText.scrollToBottomWithCountLabel(unseenMessageCount) : localeText.scrollToBottomLabel, [localeText, unseenMessageCount]);
  const ownerState = React.useMemo(() => ({
    isAtBottom,
    unseenMessageCount,
    label
  }), [isAtBottom, label, unseenMessageCount]);
  const Root = slots?.root ?? 'button';
  const Badge = slots?.badge ?? 'span';
  const Icon = slots?.icon;
  const rootSlotProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps?.root,
    externalForwardedProps: other,
    ownerState,
    additionalProps: _extends({
      ref,
      type: 'button',
      'aria-label': label
    }, getDataAttributes({
      isAtBottom: ownerState.isAtBottom,
      unseenMessageCount: ownerState.unseenMessageCount
    }))
  });
  const rootProps = mergeReactProps(rootSlotProps, {
    onClick: () => {
      scrollToBottom({
        behavior: scrollBehavior
      });
    }
  });
  const badgeProps = useSlotProps({
    elementType: Badge,
    externalSlotProps: slotProps?.badge,
    ownerState
  });
  const iconProps = useSlotProps({
    elementType: Icon ?? 'svg',
    externalSlotProps: slotProps?.icon,
    ownerState
  });
  if (isAtBottom) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Root, _extends({}, rootProps, {
    children: [Icon ? /*#__PURE__*/_jsx(Icon, _extends({}, iconProps)) : /*#__PURE__*/_jsx("span", {
      children: localeText.scrollToBottomLabel
    }), unseenMessageCount > 0 ? /*#__PURE__*/_jsx(Badge, _extends({}, badgeProps, {
      children: unseenMessageCount
    })) : null]
  }));
});
if (process.env.NODE_ENV !== "production") ScrollToBottomAffordance.displayName = "ScrollToBottomAffordance";